import React, { useContext, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
// import './assets/style/FontFoemate.css'
import "./assets/style/main.css";
import AdminLogin from "./pages/AdminLogin";
import SelfService from "./pages/SelfService";
import PromptWorkbench from "./pages/PromptWorkbench";

import AccessCode from "./pages/AccessCode";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AppContext } from "./context/AppContext";
import JobList from "./pages/JobList";
import JobDescription from "./pages/JobDescription";
import AddQuestion from "./pages/JobDescriptionScreens/AssesmentScreens/AddQuestion";
import CreateQuestion from "./pages/JobDescriptionScreens/AssesmentScreens/CreateQuestion";
import NewHeader from "./component/NewHeader";
import JobAnalysis from "./pages/JobAnalysis";
import Behaviors from "./pages/Behaviors";
import Topics from "./pages/Topics";
import SubTopics from "./pages/SubTopics";
import TotalMarketing from "./pages/TotalMarketing";
import AddEditGroup from "./pages/addEditGroup";
import JobJD from "./pages/jd";
import BehaviorsPage from "./pages/BehaviorsPage";
import NewSkill from "./component/Skill/NewSkill";
import ExcelChart from "./component/EcelGraph";

import JobDatas from "./pages/JobDatas";
import SupervisiorPersonality from "./pages/supervissiorPer";
import { PostCallWithErrorResponse, simpleGetCallWithErrorResponse } from "./Api/ApiServices";
import { ApiConfig } from "./Api/ApiConfig";
import { toastMsg } from "./component/toast";
import CandidateProfile from "./pages/CandidateProfile";
import DetailedPersonality from "./pages/detailedPersonality";
import DetailedPersonalityReport from "./pages/NewDetailedPersonality";
import NewDetailedPersonality from "./pages/NewDetailedPersonality";
import CandidateDashboard from "./pages/candidateDashnoard";
import PersonalityReport from "./pages/personalityReport";
import AssessmentNew from "./pages/App2";
import Newguide from "./pages/App";
import Reorder from "./pages/Reorder";
import CandidateSummary1 from "./pages/candidateSummaryReport1";

function App() {
  const pathName = useLocation().pathname;

  const [searchParams] = useSearchParams()

  const { isLogin, setIsLogin, setAdminData } = useContext(AppContext);
  const login = localStorage.getItem("userId");

  const navigate = useNavigate();

  // useEffect(() => {
  //   if (isLogin && pathName == "/Login") {
  //     navigate("/");
  //   } else {
  //     navigate(pathName);
  //   }
  // }, [isLogin, pathName]);
  useEffect(() => {

    // navigate("/Login");

    // return;

    let token = searchParams.get('token')

    let code = searchParams.get('code')

    if (token) {

      simpleGetCallWithErrorResponse(ApiConfig.AUTHORIZE_WITH_TOKEN + encodeURIComponent(token)).then((res) => {

        if (res?.json?.response?.status) {



          localStorage.setItem(
            "admin",
            JSON.stringify(res?.json?.response?.result)
          );
          localStorage.setItem("email", JSON.stringify(res?.json?.response?.email));
          localStorage.setItem("userId", JSON.stringify(res?.json?.response?.userId));
          localStorage.setItem(
            "auth_token",
            JSON.stringify(res?.json?.response?.token)
          );
          localStorage.setItem(
            "isHaveJd",
            JSON.stringify(res?.json?.response?.isJDUser)
          );

          setIsLogin(true);
          setAdminData(prev => ({
            ...prev,
            userId: res?.json?.response?.userId,
            email: res?.json?.response?.email,
            auth_token: res?.json?.response?.token,
            isHaveJd: res?.json?.response?.isJDUser,
            admin: res?.json?.response?.result

          }))
          if (code) {
            navigate('/candidateList/' + code)
          } else {
            navigate('/')
          }

        } else {
          toastMsg('error', res?.json?.response?.message)
          navigate('/login')
        }

      })

      return
    }


    if (pathName == "/graph" || pathName.includes('/personalityReport') || pathName.includes('/candidateDashboard')) {
      return
    }
    if (!isLogin && pathName !== "/Login") {
      // Redirect to login if not logged in
      navigate("/Login");
    } else if (isLogin && pathName === "/Login") {


      // Redirect to home if logged in and still on login page
      navigate("/");
    }
    // No action if isLogin && pathName !== "/Login"
  }, [isLogin, pathName, navigate]);

  return (
    <div>
      <ToastContainer />
      <div>
        {/* {pathName === "/" && <SelfService />} */}
        {/* {pathName !== "/" && pathName !== "/Login" && pathName !== "/graph" && !pathName.includes('/personalityReport') && !pathName.includes('/candidateDashboard') && <NewHeader />} */}
        <Routes>
          <Route path="/Login" element={<Newguide />} />
          <Route exact path="/Login" element={<AdminLogin />} />
          <Route path="/jobDescription" element={<JobDescription />} />
          <Route path="/addEditGroup/:code" element={<AddEditGroup />} />
          <Route path="/JobList" element={<JobList />} />
          <Route path="/assessmentGenerator" element={<AddQuestion />} />
          <Route path="/createQuestion" element={<CreateQuestion />} />
          <Route path="/JobAnalysis" element={<JobAnalysis />} />
          <Route path="/Behaviors" element={<Behaviors />} />
          <Route path="/Topics" element={<Topics />} />
          <Route path="/SubTopics" element={<SubTopics />} />
          <Route path="/TotalMarketing" element={<TotalMarketing />} />
          <Route path="/jdjob" element={<JobJD />} />
          <Route path="/BehaviorsPage" element={<BehaviorsPage />} />
          <Route path="/NewSkill" element={<NewSkill />} />
          <Route path="/JobDatas" element={<JobDatas />} />
          <Route path="/graph" element={<ExcelChart />} />
          <Route path="/CandidateProfile/:code/:userId" element={<CandidateProfile />} />
          <Route path="/DetailedPersonalityReport" element={<DetailedPersonalityReport />} />
          <Route path="/DetailedPersonalityReport/:code/:userId" element={<NewDetailedPersonality />} />
          <Route path="/supervsiorPersonality" element={<SupervisiorPersonality />} />
          <Route element={<AccessCode />} path="/candidateList/:code" />
          <Route element={<CandidateSummary1 />} path='/candidateDashboard/:code/:userId' />
          <Route path="/personalityReport/:code/:userId" element={<PersonalityReport />} />
          <Route path="/PromptWorkbench" element={<PromptWorkbench />} />

          <Route path="/AssessmentNew" element={<AssessmentNew />} />
          <Route path="/reorder" element={<Reorder />} />
        </Routes>
      </div>
    </div>
  );
}



export default App;

